/* historIA order wizard.
   Steps (2 in the store: hero + story with an optional "add more" box, then package + consent) -> one cart line: the package variant + line-item properties + the photos as file properties.
   Two modes from the same file:
   - preview (site/order.html): the last button shows the payload instead of paying;
   - store (Shopify product page, plan inputs carry data-variant): POST /cart/add.js, then the cart.
   Every visible string comes from I18N (Hebrew defaults below; the theme injects #wz-i18n per language).
   Text answers are kept in localStorage (photos cannot be), so a reload loses nothing typed. */
(() => {
  const W = document.getElementById('wizard');
  if (!W) return;
  const I18N = Object.assign({
    add_photos: 'הוספת תמונות', char_photos: 'תמונות של הדמות', one_photo: 'תמונה אחת', n_photos: '{n} תמונות', add_more: '{x} · להוסיף עוד',
    rm_photo: 'להסיר את תמונה {n}', step_of: 'שלב {a} מתוך {b}', missing: 'חסר: ',
    e_name: 'השם', e_age: 'גיל בין 1 ל־14', e_gender: 'בן או בת', e_photo: 'לפחות תמונה אחת', e_cname: 'שם לדמות {n}',
    e_crel: 'מי זו דמות {n}', e_cphoto: 'תמונה של דמות {n}', e_topic: 'נושא', e_own: 'כמה מילים על הרעיון',
    e_style: 'שבת וחגים בסיפור, כן או לא', e_plan: 'חבילה', e_phone: 'מספר טלפון', e_street: 'רחוב ומספר בית', e_city: 'עיר', e_zip: 'מיקוד', e_unit: 'קומה ודירה (או בית פרטי)', e_guardian: 'אישור ההורים', e_ai: 'אישור השימוש בתמונות', e_terms: 'אישור ההורים והסכמה לתקנון',
    s_title: 'ההזמנה שלכם', s_hero: 'הגיבור', s_more: 'עוד בסיפור', s_story: 'הסיפור', s_look: 'הסגנון', s_edit: 'לשנות',
    s_only: 'רק הגיבור', s_age: 'גיל {n}', s_loves_m: 'אוהב: ', s_loves_f: 'אוהבת: ', s_modest: 'איורים צנועים', s_ded: 'עם הקדשה',
    p_name: 'שם הגיבור', p_age: 'גיל', p_gender: 'בן או בת', p_topic: 'נושא', p_now: 'קורה עכשיו', p_love: 'מה אוהב',
    p_lang: 'שפת הספר', p_style: 'שבת וחגים', p_modest: 'איורים צנועים', p_ded: 'הקדשה', p_phone: 'טלפון', p_address: 'כתובת למשלוח', p_ai: 'אישור תמונות ל-Google ו-Higgsfield',
    p_char: 'דמות {n}', p_hero_photo: '_תמונה גיבור {i}', p_char_photo: '_תמונה דמות {n} {i}',
    wa_intro: 'היי, אני באמצע הזמנה של ספר מ־historIA ואשמח להתייעץ',
    sending: 'מעלים את התמונות...', send_fail: 'משהו השתבש בהעלאה. נסו שוב, או כתבו לנו בוואטסאפ.',
    coupon_ok: 'הקוד נקלט. ההנחה תופיע בעגלה ובתשלום.', coupon_bad: 'הקוד הזה לא תקף. כדאי לבדוק שהוא הוקלד נכון.', coupon_saved: 'הקוד נשמר ויופעל בעגלה.',
    send_fail_link: 'להשלמת ההזמנה בוואטסאפ', send_fail_wa: 'שלום, ניסיתי להזמין ספר באתר וההעלאה לא עברה. שם הגיבור: {name}, טלפון: {phone}',
    done_plan: 'חבילה', done_photos: 'תמונות', n_files: '{n} קבצים',
    s_extra: 'עם עותק נוסף', p_copy_of: 'עותק נוסף של הספר של',
    wa_order_intro: 'שלום, אני רוצה להזמין ספר מ־historIA', wa_plan: 'חבילה', wa_extra: 'עותק נוסף של אותו ספר',
    p_topic2: 'נושא לספר 2', p_topic3: 'נושא לספר 3', e_topic2: 'נושא לספר השני', e_topic3: 'נושא לספר השלישי',
    p_addon_of: 'תוספת לספר של', p_gift_note: 'ברכה בכרטיס',
    wa_photos: 'תמונות', wa_photos_fail: 'לא הצלחנו להעלות את התמונות באתר, אז נשלח אותן כאן בשיחה.',
    e_fmt: 'גודל הספר', p_fmt: 'פורמט', sum_fmt: 'ספר גדול לרוחב ⁦29×21⁩', e_cage: 'הגיל של דמות {n}', p_char_age: 'גיל (דמות {n})', c_incl: 'כלול', c_add: '+{p} ₪', add_price: ' (+{p} ₪)', fp_photos: 'תמונות לעמוד המשפחתי', e_fphoto: 'תמונות לעמוד המשפחתי',
    p_fpage: 'עמוד תמונות משפחתי', p_fpage_photo: '_תמונה עמוד משפחתי {i}', p_xc: 'דמויות נוספות',
    sum_h: 'סיכום ההזמנה', sum_xc1: 'דמות נוספת אחת', sum_xc: '{n} דמויות נוספות', sum_fam: '3 דמויות נוספות ("כל המשפחה")',
    sum_fp: 'עמוד תמונות משפחתי', sum_copy: 'עותק נוסף', sum_books: ' × {n} ספרים', sum_cart: 'כבר בעגלה',
    sum_sib: 'ספר שני לאח או לאחות', sum_total: 'סך הכל', ship_left: 'עוד {x} ₪ והמשלוח חינם 🎁', ship_free_g: 'המשלוח חינם 🎁',
    p_st: 'סיפורים נוספים', p_st_topic: 'נושא (סיפור נוסף {i})', e_st_own: 'הנושא לסיפור נוסף {i}', sum_st1: 'סיפור נוסף', sum_st: '{n} סיפורים נוספים',
    fmt_gone: 'הפורמט הגדול אזל ממש עכשיו. אפשר לבחור את הספר המרובע ולהמשיך.'
  }, (() => { try {   // Shopify's t filter HTML-escapes plain keys (l'accord -> l&#39;accord); these strings go to textContent and WhatsApp, so decode once
    const o = JSON.parse(document.getElementById('wz-i18n').textContent), t = document.createElement('textarea');
    for (const k in o) { t.innerHTML = o[k]; o[k] = t.value; }
    return o; } catch (e) { return {}; } })());
  const f = (s, o) => s.replace(/\{(\w+)\}/g, (_, k) => o[k]);

  const form = W.querySelector('.wz__form'), steps = [...W.querySelectorAll('.wz-step')];
  const prog = [...W.querySelectorAll('.wz__prog li')], count = W.querySelector('.wz__count');
  const errBox = W.querySelector('.wz-err'), next = W.querySelector('.wz-next'), back = W.querySelector('.wz-back'), pay = W.querySelector('.wz-pay');
  const charsBox = W.querySelector('.chars'), tpl = document.getElementById('tpl-char');
  const done = W.querySelector('.wz-done');
  // 2.11: 1600px is plenty for drawing a face, and a dozen 2400px photos crossed Shopify's ~20 MB request limit (413 -> "something went wrong")
  const KEY = 'historia_wizard_' + (document.documentElement.lang || 'he'), MAX_SIDE = 1600, UPLOAD_BUDGET = 15e6;
  const PHONE = W.dataset.phone || '972539089023';
  const STORE = !!W.querySelector('[data-variant]');
  const WA_MODE = W.dataset.mode === 'whatsapp';   // no payment provider yet: the order goes to WhatsApp, photos as links
  const LOG = W.dataset.log || '';      // order-log webhook (theme setting); empty = nothing leaves the page but the WhatsApp link
  const photos = { hero: [] };          // owner -> [{ blob, url, name }]
  /* 3.11 Yonatan: the book includes the hero + 2 family members; up to 3 more characters at 20 each (3 = "כל המשפחה" 49),
     so 6 in the book at most - faces stay exact up to that. Prices come from the unlisted "extra-characters" product
     (data-xc = "id:cents," per variant: 1, 2, 3 extra); without it no price is shown, the cap stays. Add-ons are per book. */
  const XC = (W.dataset.xc || '').split(',').filter(Boolean).map(x => { const [id, c] = x.split(':'); return { id, p: +c / 100 }; });
  const INCL = 2, MAXC = 5, LIMIT = { fpage: 6 }, FREE_SHIP = 299, SIB_OFF = 40;   // SIB_OFF: the automatic second-book discount
  let cur = 0, nChar = 0;
  /* 3.11 (test theme): more stories with the same child - any number, 49 each, each with its own topic or "you choose".
     The rows carry no data-k: they are not part of the saved draft, and a hidden block (another plan) counts as zero. */
  const stBox = W.querySelector('.wz-st');
  const stRows = () => stBox ? [...stBox.querySelectorAll('.wz-st__row')] : [];
  const stN = () => stBox && !stBox.hidden ? stRows().length : 0;   // hidden = another plan (its own data-for-plan), not another step
  const stOwn = r => r.querySelector('select').selectedOptions[0].hasAttribute('data-own');
  const stTopic = r => stOwn(r) ? [r.querySelector('select').value, r.querySelector('input').value.trim()].filter(Boolean).join(': ') : r.querySelector('select').value;
  function stUI() {
    if (!stBox) return;
    stRows().forEach((r, i) => { r.querySelector('.n').textContent = i + 1; r.querySelector('input').hidden = !stOwn(r); });
    stBox.querySelector('.wz-st__n').textContent = stRows().length;
    stBox.querySelector('[data-st="-"]').disabled = !stRows().length;
  }
  if (stBox) {
    stBox.querySelector('[data-st="+"]').onclick = () => { stBox.querySelector('.wz-st__rows').append(stBox.querySelector('template').content.cloneNode(true)); stUI(); renderSum(); };
    stBox.querySelector('[data-st="-"]').onclick = () => { const r = stRows().pop(); if (r) r.remove(); stUI(); renderSum(); };
    stBox.addEventListener('change', stUI);
    stUI();
  }

  /* ---------- photos: shrink on the device (fast upload), keep the original if the browser cannot decode it ---------- */
  // 2.11: iPhone photos (24-48 MP, sometimes HEIC) can make createImageBitmap fail; an <img> decodes anything Safari can
  // show, so it is the fallback - otherwise the untouched original (several MB) was uploaded and the upload crawled
  const decodeImg = file => new Promise((res, rej) => {
    const u = URL.createObjectURL(file), im = new Image();
    im.onload = () => res({ src: im, w: im.naturalWidth, h: im.naturalHeight, done: () => URL.revokeObjectURL(u) });
    im.onerror = () => { URL.revokeObjectURL(u); rej(new Error('decode')); };
    im.src = u;
  });
  async function decode(file) {
    try {
      // older Safari throws on the options object - retry without it before falling back to <img>
      const bmp = await createImageBitmap(file, { imageOrientation: 'from-image' }).catch(() => createImageBitmap(file));
      return { src: bmp, w: bmp.width, h: bmp.height, done: () => bmp.close && bmp.close() };
    } catch (e) { return decodeImg(file); }
  }
  async function shrink(file, side = MAX_SIDE, q = 0.85) {
    try {
      const img = await decode(file);
      const k = Math.min(1, side / Math.max(img.w, img.h));
      if (k === 1 && file.type === 'image/jpeg' && file.size < 1.5e6) { img.done(); return file; }
      const c = document.createElement('canvas'); c.width = Math.round(img.w * k); c.height = Math.round(img.h * k);
      c.getContext('2d').drawImage(img.src, 0, 0, c.width, c.height); img.done();
      return await new Promise(r => c.toBlob(b => r(b && b.size < file.size ? b : file), 'image/jpeg', q));
    } catch (e) { return file; }
  }
  // all photos travel in ONE cart request; keep it under the budget by shrinking harder before giving up
  async function fitBudget(files) {
    const total = () => files.reduce((n, [, b]) => n + b.size, 0);
    for (const [side, q] of [[1280, 0.8], [1024, 0.75]]) {
      if (total() <= UPLOAD_BUDGET) break;
      for (const it of files) it[1] = await shrink(it[1], side, q);
    }
    return total() <= UPLOAD_BUDGET * 1.25;   // Shopify refuses ~20 MB; past this, say so instead of a failed upload
  }
  const nPhotos = n => n === 1 ? I18N.one_photo : f(I18N.n_photos, { n });
  function renderPhotos(box, owner) {
    const grid = box.querySelector('.ph__grid'), list = photos[owner];
    grid.innerHTML = '';
    list.forEach((p, i) => {
      const li = document.createElement('li');
      li.innerHTML = `<img src="${p.url}" alt=""><button type="button" class="ph__rm" aria-label="${f(I18N.rm_photo, { n: i + 1 })}">×</button>`;
      li.querySelector('button').onclick = () => { URL.revokeObjectURL(p.url); list.splice(i, 1); renderPhotos(box, owner); save(); };
      grid.appendChild(li);
    });
    box.classList.toggle('has-photos', list.length > 0);
    const cta = box.querySelector('.ph__cta');
    if (cta) cta.textContent = list.length ? f(I18N.add_more, { x: nPhotos(list.length) }) : (owner === 'hero' ? I18N.add_photos : owner === 'fpage' ? I18N.fp_photos : I18N.char_photos);
    if (owner === 'fpage') renderSum();
  }
  function initPhotos(box, owner) {
    photos[owner] = photos[owner] || [];
    const inp = box.querySelector('input[type=file]'), drop = box.querySelector('.ph__drop');
    const add = async files => {
      box.classList.add('is-busy');
      for (const fl of files) {
        if (LIMIT[owner] && photos[owner].length >= LIMIT[owner]) break;
        if (!fl.type.startsWith('image/') && !/\.(heic|heif)$/i.test(fl.name)) continue;
        const b = await shrink(fl);
        photos[owner].push({ blob: b, url: URL.createObjectURL(b), name: fl.name });
      }
      box.classList.remove('is-busy'); renderPhotos(box, owner); clearErr(box);
    };
    inp.addEventListener('change', () => { add([...inp.files]); inp.value = ''; });
    ['dragenter', 'dragover'].forEach(t => drop.addEventListener(t, e => { e.preventDefault(); drop.classList.add('is-over'); }));
    ['dragleave', 'drop'].forEach(t => drop.addEventListener(t, e => { e.preventDefault(); drop.classList.remove('is-over'); }));
    drop.addEventListener('drop', e => add([...e.dataTransfer.files]));
    renderPhotos(box, owner);
  }

  /* ---------- extra characters ---------- */
  function addChar(data) {
    const id = 'c' + (++nChar), el = tpl.content.firstElementChild.cloneNode(true);
    el.dataset.id = id;
    el.querySelectorAll('.field').forEach((fd, i) => { const c = fd.querySelector('input,select'); c.id = `${id}-${i}`; fd.querySelector('label').htmlFor = c.id; });
    if (data) { el.querySelector('[data-k=cname]').value = data.cname || ''; el.querySelector('[data-k=crel]').value = data.crel || '';
      const ag = el.querySelector('[data-k=cage]'); if (ag) ag.value = data.cage || ''; }
    el.querySelector('.char__rm').onclick = () => { (photos[id] || []).forEach(p => URL.revokeObjectURL(p.url)); delete photos[id]; el.remove(); number(); save(); };
    charsBox.appendChild(el); initPhotos(el.querySelector('.ph'), id); number();
    return el;
  }
  function number() { charsBox.querySelectorAll('.char').forEach((c, i) => { c.querySelector('.char__n').textContent = i + 1; }); chargeUI(); }
  const extraN = () => Math.min(3, Math.max(0, charsBox.querySelectorAll('.char').length - INCL));
  const money = n => `<span dir="ltr">${n}&nbsp;₪</span>`;
  function chargeUI() {
    const cs = charsBox.querySelectorAll('.char'), n = cs.length;
    cs.forEach((c, i) => {
      const b = c.querySelector('.char__price'); if (!b) return;
      b.hidden = !XC.length; if (!XC.length) return;
      b.className = 'char__price ' + (i < INCL ? 'char__price--in' : 'char__price--add');
      b.innerHTML = i < INCL ? I18N.c_incl : `<span dir="ltr">${f(I18N.c_add, { p: XC[0].p })}</span>`;
    });
    const addB = W.querySelector('.wz-add'), cap = W.querySelector('.wz-cap'), fam = W.querySelector('.wz-family'), ap = W.querySelector('.wz-add__price');
    addB.hidden = n >= MAXC; if (cap) cap.hidden = n < MAXC;
    if (ap) { ap.hidden = !XC.length || n < INCL; if (XC.length) ap.textContent = f(I18N.add_price, { p: XC[0].p }); }
    if (fam) { fam.hidden = !(XC.length >= 3 && extraN() === 3); if (!fam.hidden) fam.querySelector('b').innerHTML = `<s>${money(XC[0].p * 3)}</s> ${money(XC[2].p)}`; }
    renderSum();
  }
  W.querySelector('.wz-add').onclick = () => { const el = addChar(); el.querySelector('input').focus(); save(); };

  /* ---------- reading the answers ---------- */
  const pick = k => [...form.querySelectorAll(`.wz-step [data-k="${k}"]`)].filter(e => !e.closest('.char'))
    .find(x => (x.type === 'radio' || x.type === 'checkbox') ? x.checked : true);
  const phoneOk = () => /^\d{9,15}$/.test(val('phone').replace(/[\s\-().+]/g, ''));
  const val = k => { const e = pick(k); return e ? ((e.type === 'checkbox' && !e.checked) ? '' : e.value.trim()) : ''; };
  const code = k => { const e = pick(k); return e && e.checked ? (e.dataset.code || '') : ''; };
  const chars = () => [...charsBox.querySelectorAll('.char')].map(c => ({ id: c.dataset.id, cname: c.querySelector('[data-k=cname]').value.trim(), crel: c.querySelector('[data-k=crel]').value,
    cage: ((c.querySelector('[data-k=cage]') || {}).value || '').trim() }));
  const girl = () => code('gender') === 'girl';
  const own = () => code('topic') === 'own';
  W.querySelectorAll('[data-hero-name]').forEach(s => { s.dataset.heroName = s.textContent; });
  function personalise() {
    W.querySelectorAll('[data-hero-name]').forEach(s => { s.textContent = val('name') || s.dataset.heroName; });
    const g = girl() ? 1 : 0;
    W.querySelectorAll('[data-g]').forEach(s => { s.textContent = s.dataset.g.split('|')[g]; });
    W.querySelector('[data-own]').hidden = !own();
  }

  /* ---------- keep typed answers ---------- */
  function save() {
    const d = {}; form.querySelectorAll('[data-k]').forEach(e => { if (e.closest('.char')) return;
      if (e.type === 'radio') { if (e.checked) d[e.dataset.k] = e.value; } else if (e.type === 'checkbox') d[e.dataset.k] = e.checked; else d[e.dataset.k] = e.value; });
    d.chars = chars();
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
  }
  function load() {
    let d = null; try { d = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (d) {
      form.querySelectorAll('[data-k]').forEach(e => { if (e.closest('.char') || !(e.dataset.k in d)) return;
        if (e.type === 'radio') e.checked = d[e.dataset.k] === e.value; else if (e.type === 'checkbox') e.checked = !!d[e.dataset.k]; else e.value = d[e.dataset.k]; });
      (d.chars || []).slice(0, MAXC).forEach(c => addChar(c));   // an old draft may hold more than the cap
    }
    // a link from the landing page can choose the package or the topic: ?plan=premium, ?topic=birthday
    const q = new URLSearchParams(location.search);
    const setCode = (k, c) => { const e = form.querySelector(`[data-k="${k}"][data-code="${c}"]`); if (e) e.checked = true; };
    if (q.get('plan')) setCode('plan', q.get('plan'));
    if (q.get('topic')) setCode('topic', q.get('topic'));
    // 1.11: a saved draft or an old link may name a package that no longer exists (premium) - fall back to the first one
    if (!form.querySelector('[data-k="plan"]:checked')) { const p0 = form.querySelector('[data-k="plan"]'); if (p0) p0.checked = true; }
    // the name typed on the landing page's cover (?name=, 28.10) fills an empty name field
    const nm = form.querySelector('[data-k="name"]');
    if (nm && !nm.value && q.get('name')) nm.value = q.get('name').slice(0, 20);
  }

  /* ---------- checking a step ---------- */
  function clearErr(scope) { scope.querySelectorAll('.is-err').forEach(e => e.classList.remove('is-err')); if (scope === form || scope.closest('.wz-step')) errBox.textContent = ''; }
  function mark(el) { (el.closest('.field, .check, fieldset, .ph') || el).classList.add('is-err'); }
  function check(i) {
    const s = steps[i], bad = [], msgs = [];
    clearErr(s);
    const need = (el, msg) => { mark(el); bad.push(el); msgs.push(msg); };
    // checks follow the fields a step holds, not its number: the store has 2 steps, the static preview still has 5
    const has = k => s.querySelector(`[data-k="${k}"]`);
    if (has('name')) {
      if (!val('name')) need(has('name'), I18N.e_name);
      const a = +val('age'); if (!a || a < 1 || a > 14) need(has('age'), I18N.e_age);
      if (!val('gender')) need(has('gender'), I18N.e_gender);
      if (!photos.hero.length) need(s.querySelector('.ph[data-owner=hero] .ph__drop input'), I18N.e_photo);
    }
    if (s.contains(charsBox)) charsBox.querySelectorAll('.char').forEach((c, n) => {
      const nm = c.querySelector('[data-k=cname]'), rel = c.querySelector('[data-k=crel]');
      if (!nm.value.trim()) need(nm, f(I18N.e_cname, { n: n + 1 }));
      if (!rel.value) need(rel, f(I18N.e_crel, { n: n + 1 }));
      const ag = c.querySelector('[data-k=cage]'); if (ag && !ag.value.trim()) need(ag, f(I18N.e_cage, { n: n + 1 }));   // 3.11: every character's age
      if (!(photos[c.dataset.id] || []).length) need(c.querySelector('.ph__drop input'), f(I18N.e_cphoto, { n: n + 1 }));
    });
    // a mobile number: 9-15 digits once spaces, dashes, brackets and a leading + are dropped (Israeli or foreign).
    // 2.11: checked wherever the field sits - the store asks it on step 1, the static preview still on its last step
    if (has('phone') && !phoneOk()) need(has('phone'), I18N.e_phone);
    if (has('topic')) {
      if (!val('topic')) need(has('topic'), I18N.e_topic);
      if (own() && !val('own')) need(has('own'), I18N.e_own);
    }
    if (has('style') && has('style').required && !val('style')) need(has('style'), I18N.e_style);
    if (has('plan')) {
      if (!val('plan')) need(has('plan'), I18N.e_plan);
      if (planCode() === 'collection') ['2', '3'].forEach(n => {
        const sel = has('topic' + n); if (!sel) return;
        if (!sel.value || (sel.selectedOptions[0].hasAttribute('data-own') && !val('own' + n))) need(sel, I18N['e_topic' + n]);
      });
      ['street', 'city', 'zip', 'unit'].forEach(k => { const e = has(k); if (e && e.required && !val(k)) need(e, I18N['e_' + k]); });
      const fmtBox = s.querySelector('.wz-fmt'); if (fmtBox && !fmtBox.hidden && !val('fmt')) need(fmtBox.querySelector('input'), I18N.e_fmt);
      if (stN()) stRows().forEach((r, i) => { if (stOwn(r) && !r.querySelector('input').value.trim()) need(r.querySelector('input'), f(I18N.e_st_own, { i: i + 1 })); });
      if (has('fpage') && val('fpage') && !photos.fpage.length) need(s.querySelector('.ph[data-owner=fpage] .ph__drop input'), I18N.e_fphoto);
      if (has('guardian') && !val('guardian')) need(has('guardian'), I18N.e_guardian);
      if (!val('aiconsent')) need(has('aiconsent'), I18N.e_ai);
      if (!val('terms')) need(has('terms'), I18N.e_terms);
    }
    if (bad.length) {
      errBox.textContent = I18N.missing + msgs.join(', ');
      const first = bad[0].type === 'file' ? bad[0].closest('.ph__drop') : bad[0];
      const box = first.closest('details'); if (box) box.open = true;   // an error inside the closed "add more" box
      first.focus();
    }
    return !bad.length;
  }

  /* ---------- summary ---------- */
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  function summary() {
    if (!W.querySelector('.sum')) return;   // the compact store wizard has no summary block
    const cs = chars(), rows = [
      [I18N.s_hero, `${val('name')}, ${val('gender')}, ${f(I18N.s_age, { n: val('age') })} · ${nPhotos(photos.hero.length)}`, 0],
      [I18N.s_more, cs.length ? cs.map(c => `${c.cname} (${c.crel}, ${nPhotos((photos[c.id] || []).length)})`).join(' · ') : I18N.s_only, 1],
      [I18N.s_story, [own() ? val('own') : val('topic'), val('now'), val('love') && (girl() ? I18N.s_loves_f : I18N.s_loves_m) + val('love')].filter(Boolean).join(' · '), 2],
      [I18N.s_look, [val('lang'), val('style'), val('modest') && I18N.s_modest, val('dedication') && I18N.s_ded, val('extra') && I18N.s_extra].filter(Boolean).join(' · '), 3],
    ];
    W.querySelector('.sum').innerHTML = `<h3 class="sum__h">${I18N.s_title}</h3><dl>` + rows.map(([k, v, st]) =>
      `<div><dt>${k}</dt><dd>${esc(v)}</dd><dd class="sum__ed"><button type="button" data-go="${st}">${I18N.s_edit}</button></dd></div>`).join('') + '</dl>';
    W.querySelectorAll('[data-go]').forEach(b => b.onclick = () => go(+b.dataset.go));
  }

  /* ---------- the order payload ---------- */
  function payload() {
    const props = [], files = [];
    const add = (k, v) => { if (v) props.push([k, v]); };
    add(I18N.p_name, val('name')); add(I18N.p_age, val('age')); add(I18N.p_gender, val('gender'));
    add(I18N.p_topic, own() ? val('topic') + ': ' + val('own') : val('topic'));
    if (planCode() === 'collection') ['2', '3'].forEach(n => {
      const sel = form.querySelector(`[data-k="topic${n}"]`), own = sel && sel.selectedOptions[0] && sel.selectedOptions[0].hasAttribute('data-own');
      add(I18N['p_topic' + n], [val('topic' + n), own && val('own' + n)].filter(Boolean).join(': '));
    });
    add(I18N.p_now, val('now')); add(I18N.p_love, val('love'));
    add(I18N.p_lang, val('lang')); add(I18N.p_style, val('style')); add(I18N.p_modest, val('modest'));
    add(I18N.p_ded, val('dedication'));
    add(I18N.p_phone, val('phone'));
    add(I18N.p_address, [val('street'), val('unit'), [val('zip'), val('city')].filter(Boolean).join(' ')].filter(Boolean).join(', '));
    add(I18N.p_ai, val('aiconsent'));   // the consent travels with the order (operator decision 24.10)
    const cs = chars(); cs.forEach((c, i) => { add(f(I18N.p_char, { n: i + 2 }), `${c.cname} - ${c.crel}`); add(f(I18N.p_char_age, { n: i + 2 }), c.cage); });
    // NOT 'גיל דמות N': Make 8209625 finds a character by splitting the details on 'דמות N:' and taking the LAST part
    // keyed by position, not by name: two characters may share a name and a key would overwrite the other's photos
    photos.hero.forEach((p, i) => files.push([f(I18N.p_hero_photo, { i: i + 1 }), p.blob]));
    cs.forEach((c, n) => (photos[c.id] || []).forEach((p, i) => files.push([f(I18N.p_char_photo, { n: n + 2, i: i + 1 }), p.blob])));
    // 3.11: the add-ons (extra characters, family page) are separate cart lines, one per book; the book line names them
    const nb = books(), xn = extraN(), fpEl = W.querySelector('.wz-page'), fpOn = !!(fpEl && val('fpage') && photos.fpage);
    if (XC.length && xn) add(I18N.p_xc, String(xn));
    if (fpOn) { add(I18N.p_fpage, nPhotos(photos.fpage.length)); photos.fpage.forEach((p, i) => files.push([f(I18N.p_fpage_photo, { i: i + 1 }), p.blob])); }
    const addLines = [];
    if (XC.length && xn) addLines.push({ id: XC[xn - 1].id, quantity: nb });
    if (fpOn) addLines.push({ id: fpEl.dataset.variant, quantity: nb });
    // 3.11 format (test theme): the choice is a property of the book; the large one is also an add-on line (+15 per book)
    const fmtEl = W.querySelector('.wz-fmt');
    if (fmtEl && !fmtEl.hidden && val('fmt')) { add(I18N.p_fmt, val('fmt')); if (code('fmt') === 'large') addLines.push({ id: fmtEl.dataset.variant, quantity: nb }); }
    const sn = stN();   // 3.11: the extra stories - one line, quantity = how many; the book line lists each topic
    if (sn) { add(I18N.p_st, String(sn)); stRows().forEach((r, i) => add(f(I18N.p_st_topic, { i: i + 1 }), stTopic(r))); addLines.push({ id: stBox.dataset.variant, quantity: sn }); }
    const planEl = pick('plan');
    const ex = pick('extra');
    return { plan: val('plan'), variant: planEl && planEl.checked ? (planEl.dataset.variant || '') : '', props, files,
             price: planEl && planEl.checked ? (planEl.dataset.price || '') : '',
             extra: ex && ex.checked ? (ex.dataset.variant || 'preview') : '', extraPrice: ex ? (ex.dataset.price || '') : '', addLines };
  }
  window.__historiaPayload = payload;   // used by the tests

  /* ---------- 31.10 what the chosen plan needs (collection topics, no extra copy / shipping line for digital) ---------- */
  function planCode() { const e = form.querySelector('[data-k="plan"]:checked'); return e ? e.dataset.code || '' : ''; }
  const books = () => planCode() === 'collection' ? 3 : 1;
  /* 3.11 price summary at the end of step 2 + how far from free shipping (the cart says the same). Other books already in
     the cart count too; the automatic second-book discount is taken off when this book is the second personal book. */
  const sumBox = W.querySelector('.wz-sum');
  let CART = null;
  function renderSum() {
    if (!sumBox || !STORE) return;
    const pe = pick('plan'); if (!pe || !pe.checked) { sumBox.hidden = true; return; }
    const nb = books(), xn = extraN(), per = nb > 1 ? f(I18N.sum_books, { n: nb }) : '', rows = [[pe.value, +pe.dataset.price || 0]];
    if (XC.length && xn) rows.push([(xn === 3 ? I18N.sum_fam : xn === 1 ? I18N.sum_xc1 : f(I18N.sum_xc, { n: xn })) + per, XC[xn - 1].p * nb]);
    const fmtEl = W.querySelector('.wz-fmt');
    if (fmtEl && !fmtEl.hidden && code('fmt') === 'large') rows.push([I18N.sum_fmt + per, (+fmtEl.dataset.price || 0) * nb]);
    const sn = stN(); if (sn) rows.push([sn === 1 ? I18N.sum_st1 : f(I18N.sum_st, { n: sn }), (+stBox.dataset.price || 0) * sn]);
    const fpEl = W.querySelector('.wz-page');
    if (fpEl && val('fpage')) rows.push([I18N.sum_fp + per, (+fpEl.dataset.price || 0) * nb]);
    const ex = pick('extra');
    if (ex && ex.checked && !ex.closest('[hidden]')) rows.push([I18N.sum_copy, +ex.dataset.price || 0]);
    W.querySelectorAll('.wz-addon input[type=checkbox][data-variant]:checked').forEach(i => { if (!i.closest('[hidden]'))
      rows.push([(i.closest('label').querySelector('b').textContent.split(' · ')[0] || '').trim(), +i.dataset.price || 0]); });
    const others = CART ? CART.items.filter(it => !bare(it)) : [], inCart = others.reduce((n, it) => n + it.final_line_price, 0) / 100;
    if (planCode() === 'basic' && others.filter(it => it.handle === 'personal-book').length === 1 && !(CART.cart_level_discount_applications || []).length
        && !others.some(it => (it.line_level_discount_allocations || []).length)) rows.push([I18N.sum_sib, -SIB_OFF]);
    if (inCart) rows.push([I18N.sum_cart, inCart]);
    const total = rows.reduce((n, r) => n + r[1], 0);
    const ships = planCode() !== 'digital' || (ex && ex.checked) || (CART && CART.requires_shipping && inCart > 0);
    const ship = !ships ? '' : total >= FREE_SHIP ? I18N.ship_free_g : f(I18N.ship_left, { x: Math.ceil(FREE_SHIP - total) });
    sumBox.innerHTML = `<h3 class="wz-sum__h">${esc(I18N.sum_h)}</h3>` + rows.map(([k, v]) => `<div><span>${esc(k)}</span>${v < 0 ? '<span dir="ltr">-' + Math.abs(v) + '&nbsp;₪</span>' : money(v)}</div>`).join('')
      + `<div class="wz-sum__tot"><span>${esc(I18N.sum_total)}</span>${money(total)}</div>` + (ship ? `<p class="wz-sum__ship">${esc(ship)}</p>` : '');
    sumBox.hidden = false;
  }
  /* 3.11 the large format is real stock (data-left = the live inventory): sold out = off; fewer than the books = off */
  function fmtStock(gone) {
    const box = W.querySelector('.wz-fmt'), lg = box && box.querySelector('[data-k=fmt][data-code=large]'); if (!lg) return;
    if (gone) { lg.dataset.out = ''; box.dataset.left = '0'; }
    const out = lg.dataset.out !== undefined, few = box.dataset.left !== undefined && +box.dataset.left < books();
    lg.disabled = out || few; if (lg.disabled) lg.checked = false;
    lg.closest('.wz-fmt__o').classList.toggle('wz-fmt__o--out', out || few);
    const n = box.querySelector('.wz-fmt__few'); if (n) n.hidden = out || !few;
  }
  function syncPlan() {
    const code = planCode();
    W.querySelectorAll('[data-for-plan]').forEach(el => { el.hidden = !el.dataset.forPlan.split(' ').includes(code); });
    W.querySelectorAll('[data-not-plan]').forEach(el => {
      const off = el.dataset.notPlan.split(' ').includes(code); el.hidden = off;
      if (off) el.querySelectorAll('input[type=checkbox]').forEach(i => { i.checked = false; });
    });
    const fpBox = W.querySelector('.ph[data-owner=fpage]'); if (fpBox) fpBox.hidden = !val('fpage');
    fmtStock();
    W.querySelectorAll('select[data-k^="topic"]').forEach(sel => {
      const o = sel.parentElement.querySelector('[data-k^="own"]'); if (o && sel.selectedOptions[0]) o.hidden = !sel.selectedOptions[0].hasAttribute('data-own');
    });
  }
  form.addEventListener('change', e => { const k = e.target.dataset.k || ''; if (k === 'plan' || k === 'fpage' || k.startsWith('topic')) syncPlan(); });

  /* ---------- moving between steps ---------- */
  // 1.11: each forward step is a history entry, so the phone/browser Back button returns to the previous step instead of leaving the page
  function go(i, quiet, fromHistory) {
    const prev = cur;
    cur = Math.max(0, Math.min(steps.length - 1, i));
    if (!fromHistory && cur > prev && history.pushState) history.pushState(Object.assign({}, history.state, { wz: cur }), '');
    steps.forEach((s, n) => { s.hidden = n !== cur; });
    prog.forEach((p, n) => { p.classList.toggle('is-done', n < cur); p.classList.toggle('is-cur', n === cur); p.toggleAttribute('aria-current', n === cur); });
    count.textContent = f(I18N.step_of, { a: cur + 1, b: steps.length });
    back.hidden = cur === 0; next.hidden = cur === steps.length - 1; pay.hidden = cur !== steps.length - 1;
    errBox.textContent = '';
    personalise(); syncPlan(); if (cur === steps.length - 1) summary();
    if (!quiet) {
      W.querySelector('.wz__prog').scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      steps[cur].querySelector('h2').setAttribute('tabindex', '-1'); steps[cur].querySelector('h2').focus({ preventScroll: true });
    }
    save();
  }
  // 2.11 (operator: "the phone is the first thing"): leaving step 1 logs a "started" row - name + phone - so a family that
  // stops half-way can still be called back. Once per name+phone (Back/Next or a restored draft do not log it again, and
  // the newest row stays the real order for the character-sheet lookup). stage=started tells the Make scenario: sheet row
  // only, no alert email and no character-sheet run. The Meta Lead event stays on the finished order.
  const STARTED = 'historia_started';
  function logStarted() {
    if (!LOG || !val('name') || !phoneOk()) return;
    const id = val('name') + '|' + val('phone').replace(/\D/g, '');
    try { if (localStorage.getItem(STARTED) === id) return; localStorage.setItem(STARTED, id); } catch (e) {}
    const b = new URLSearchParams({ lang: document.documentElement.lang || 'he', name: val('name'), phone: val('phone'),
      stage: 'started', plan: 'התחיל ולא סיים',
      details: ['מילאו שם וטלפון ועברו לשלב הבא. עוד לא נשלחה הזמנה.', `גיל: ${val('age')}`, `${val('gender')}`, `נושא: ${val('topic')}`].join('\n') });
    try { fetch(LOG, { method: 'POST', mode: 'no-cors', keepalive: true, body: b }).catch(() => {}); } catch (e) {}
  }
  next.onclick = () => { if (check(cur)) { if (cur === 0) logStarted(); go(cur + 1); } };
  const inHistory = () => history.state && history.state.wz === cur;
  back.onclick = () => { if (cur > 0 && inHistory()) history.back(); else go(cur - 1); };
  prog.forEach((p, n) => p.addEventListener('click', () => { if (n < cur) { if (inHistory()) history.go(n - cur); else go(n); } }));
  addEventListener('popstate', e => { const s = e.state && typeof e.state.wz === 'number' ? e.state.wz : 0; if (s !== cur) go(s, false, true); });
  // fixing a field clears its mark, and once nothing in the step is marked the message goes too
  const fixed = e => { const m = e.target.closest('.is-err'); if (m) m.classList.remove('is-err'); if (!steps[cur].querySelector('.is-err')) errBox.textContent = ''; personalise(); if (cur === steps.length - 1) summary(); renderSum(); save(); };
  form.addEventListener('input', fixed);
  form.addEventListener('change', fixed);

  /* 2.11 (operator): an "order a book" button = add to cart. theme.liquid marks the click; here, on the order page, the
     book goes into the cart at once, so Shopify's add-to-cart event (-> Meta AddToCart) fires without slowing the click.
     send() then fills that same line with the answers and photos; a line with no answers ("bare") is blocked in the cart. */
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const bare = it => it.handle === 'personal-book' && !Object.keys(it.properties || {}).length;
  const getCart = () => fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).catch(() => ({ items: [] }));
  async function earlyAdd() {
    let flag = null;
    try { flag = sessionStorage.getItem('historia_atc'); sessionStorage.removeItem('historia_atc'); } catch (e) {}
    const first = form.querySelector('[data-k="plan"][data-variant]');
    if (!flag || !STORE || !first) return;
    if ((await getCart()).items.some(bare)) return;   // already waiting in the cart from an earlier click
    try { await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +first.dataset.variant, quantity: 1 }] }) }); } catch (e) {}
  }

  /* 2.11 (operator): a discount code in step 1. It is put on the CART (Shopify keeps it into checkout, where the code field
     still works too). With a book already in the cart Shopify says at once whether it applies; otherwise it waits there. */
  const couponBox = W.querySelector('.wz-coupon');
  const setCoupon = code => fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ discount: code }) }).then(r => r.json());
  async function applyCoupon() {
    const inp = couponBox.querySelector('input'), msg = couponBox.querySelector('.wz-coupon__msg');
    const code = inp.value.trim().toUpperCase(); inp.value = code; save();
    if (!code) { msg.textContent = ''; return; }
    try {
      const c = await setCoupon(code), d = (c.discount_codes || []).find(x => x.code.toUpperCase() === code);
      msg.textContent = !c.item_count ? I18N.coupon_saved : d && d.applicable ? I18N.coupon_ok : I18N.coupon_bad;
      msg.classList.toggle('is-bad', !!c.item_count && !(d && d.applicable));
    } catch (e) { msg.textContent = ''; }
  }
  if (couponBox && STORE) {
    couponBox.querySelector('.wz-coupon__go').onclick = applyCoupon;
    couponBox.querySelector('input').addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); applyCoupon(); } });
    if (val('coupon')) couponBox.open = true;   // a restored draft shows its code
  } else if (couponBox) couponBox.hidden = true;

  /* store mode: one cart line with the photos attached, then the cart (a second book can be added from there) */
  async function send(p) {
    const root = ROOT;
    if (!(await fitBudget(p.files))) throw new Error('too-big');
    // the book already put in the cart by the button: fill that line (same package) or swap it (another package)
    const early = (await getCart()).items.find(bare);
    let endpoint = 'cart/add.js', id = p.variant;
    if (early && String(early.variant_id) === String(p.variant)) { endpoint = 'cart/change.js'; id = early.key; }
    else if (early) await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: early.key, quantity: 0 }) });
    // 2.11: a slow phone connection hung here for minutes - give it 90 s, then one retry with much smaller photos
    const upload = async () => {
      const fd = new FormData();
      fd.append('id', id); fd.append('quantity', '1');
      p.props.forEach(([k, v]) => fd.append(`properties[${k}]`, v));
      p.files.forEach(([k, b], i) => fd.append(`properties[${k}]`, b, `photo-${i + 1}.jpg`));
      const ac = window.AbortController ? new AbortController() : null, t = ac && setTimeout(() => ac.abort(), 90000);
      try { return await fetch(root + endpoint, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, signal: ac && ac.signal }); }
      catch (e) { return { ok: false, status: e.name === 'AbortError' ? 'timeout' : 'network', text: async () => e.message }; }
      finally { clearTimeout(t); }
    };
    let r = await upload();
    if (!r.ok && r.status !== 422) {
      for (const it of p.files) it[1] = await shrink(it[1], 1024, 0.72);
      r = await upload();
    }
    window.__uploadInfo = { status: r.status, mb: (p.files.reduce((n, [, b]) => n + b.size, 0) / 1e6).toFixed(1), n: p.files.length };
    if (!r.ok) throw new Error(await r.text());
    const lfEl = W.querySelector('.wz-fmt'), lfLine = lfEl && p.addLines.find(l => String(l.id) === String(lfEl.dataset.variant));
    if (lfLine) {
      const rl = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: lfLine.id, quantity: lfLine.quantity, properties: { [I18N.p_addon_of]: val('name') } }] }) });
      if (!rl.ok) {   // a 422 still adds what is left (2 of 3) - that part comes out with the book
        const mine = (await getCart()).items.filter(it => (String(it.variant_id) === String(p.variant) && (it.properties || {})[I18N.p_name] === val('name'))
          || (String(it.variant_id) === String(lfLine.id) && (it.properties || {})[I18N.p_addon_of] === val('name')));
        if (mine.length) await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: Object.fromEntries(mine.map(it => [it.key, 0])) }) });
        throw new Error('fmt-gone');
      }
      p.addLines = p.addLines.filter(l => l !== lfLine);
    }
    if (p.extra) {   // the extra copy names the book it belongs to, so the order is unambiguous
      const r2 = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: p.extra, quantity: 1, properties: { [I18N.p_copy_of]: val('name') } }] }) });
      if (!r2.ok) throw new Error(await r2.text());
    }
    const addons = [...W.querySelectorAll('.wz-addon input[type=checkbox][data-variant]:checked')].filter(i => !i.closest('[hidden]'));
    if (addons.length || p.addLines.length) {
      const items = addons.map(i => ({ id: i.dataset.variant, quantity: 1, properties: Object.assign({ [I18N.p_addon_of]: val('name') },
        i.dataset.k === 'gift' && val('gift_note') ? { [I18N.p_gift_note]: val('gift_note') } : {}) }))
        .concat(p.addLines.map(l => ({ id: l.id, quantity: l.quantity, properties: { [I18N.p_addon_of]: val('name') } })));
      const r3 = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r3.ok) throw new Error(await r3.text());
    }
    if (val('coupon')) { try { await setCoupon(val('coupon').toUpperCase()); } catch (e) {} }   // the code reaches the cart even if never applied by hand
    document.dispatchEvent(new CustomEvent('historia:lead', { detail: { content_name: p.plan } }));
    try { localStorage.removeItem(KEY); } catch (e) {}
    location.href = root + 'cart';
  }
  async function waOrder(p) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    let links = [];
    try {
      const fd = new FormData();
      fd.append('id', p.variant); fd.append('quantity', '1');
      p.files.forEach(([k, b], i) => fd.append(`properties[${k}]`, b, `photo-${i + 1}.jpg`));
      const r = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error(await r.text());
      const item = await r.json();
      links = Object.entries(item.properties || {}).filter(([k, v]) => k.startsWith('_') && v).map(([k, v]) => `${k.slice(1)}: ${v}`);
      await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 0 }) });
    } catch (e) { links = []; }
    const lines = [I18N.wa_order_intro, '', `${I18N.wa_plan}: ${p.plan}${p.price ? ' (' + p.price + ' ₪)' : ''}`]
      .concat(p.extra ? [`+ ${I18N.wa_extra}${p.extraPrice ? ' (' + p.extraPrice + ' ₪)' : ''}`] : [])
      .concat([''], p.props.map(([k, v]) => `${k}: ${v}`), [''])
      .concat(p.files.length ? (links.length ? [I18N.wa_photos + ':'].concat(links) : [I18N.wa_photos_fail]) : []);
    // the order log keeps the order even if the WhatsApp message is never sent; a form post needs no CORS preflight
    if (LOG) {
      const b = new URLSearchParams({ lang: document.documentElement.lang || 'he', name: val('name'), phone: val('phone'),
        plan: p.plan, price: p.price, extra: p.extra ? (p.extraPrice || 'yes') : '', details: lines.join('\n'), photos: links.join('\n') });
      try { await fetch(LOG, { method: 'POST', mode: 'no-cors', keepalive: true, body: b }); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('historia:lead', { detail: { content_name: p.plan } }));
    return 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(lines.join('\n'));
  }
  pay.onclick = async () => {
    for (let i = 0; i < steps.length; i++) if (!check(i)) { if (i !== cur) { go(i); check(i); } return; }
    const p = payload();
    if (STORE && WA_MODE) {
      const label = pay.textContent; pay.disabled = true; pay.textContent = I18N.sending; errBox.textContent = '';
      const url = await waOrder(p);
      pay.disabled = false; pay.textContent = label;
      done.querySelector('.wz-done__go').href = url;
      try { localStorage.removeItem(KEY); } catch (e) {}
      form.hidden = true; done.hidden = false; done.focus(); done.scrollIntoView({ block: 'start' });
      return;
    }
    if (STORE) {
      const label = pay.textContent; pay.disabled = true; pay.textContent = I18N.sending; errBox.textContent = '';
      try { await send(p); } catch (e) {
        pay.disabled = false; pay.textContent = label;
        if (e.message === 'fmt-gone') { fmtStock(true); renderSum(); errBox.textContent = I18N.fmt_gone; W.querySelector('.wz-fmt').scrollIntoView({ block: 'center' }); return; }
        // 2.11: never a dead end - the message offers WhatsApp with the hero's name and phone already written
        const wa = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(f(I18N.send_fail_wa, { name: val('name'), phone: val('phone') }));
        errBox.innerHTML = `${esc(I18N.send_fail)} <a href="${wa}" target="_blank" rel="noopener">${esc(I18N.send_fail_link)}</a>`;
        // 2.11: a failed upload leaves a row in the order sheet (sheet only, like "started") with what went wrong, so the
        // family can be called back and the cause is known - no photos, only sizes and the browser
        if (LOG) try {
          const u = window.__uploadInfo || {};
          fetch(LOG, { method: 'POST', mode: 'no-cors', keepalive: true, body: new URLSearchParams({ lang: document.documentElement.lang || 'he',
            name: val('name'), phone: val('phone'), stage: 'started', plan: 'תקלה בהעלאה - לחזור ללקוח',
            details: [`שגיאה: ${u.status || e.message}`, `תמונות: ${u.n || p.files.length}, ${u.mb || '?'}MB`, navigator.userAgent].join('\n') }) }).catch(() => {});
        } catch (e2) {}
      }
      return;
    }
    done.querySelector('.wz-done__list').innerHTML = [[I18N.done_plan, p.plan], ...p.props, [I18N.done_photos, f(I18N.n_files, { n: p.files.length })]]
      .map(([k, v]) => `<div><dt>${esc(k)}</dt><dd>${esc(v)}</dd></div>`).join('');
    form.hidden = true; done.hidden = false; done.focus();
  };
  const doneBack = done && done.querySelector('.wz-done__back');   // the store's WhatsApp panel has no back button
  if (doneBack) doneBack.onclick = () => { done.hidden = true; form.hidden = false; go(steps.length - 1); };

  /* "talk to us first": WhatsApp with what has been filled in so far (never the photos) */
  W.querySelector('.wz-wa').addEventListener('click', e => {
    const p = payload(), lines = [I18N.wa_intro].concat(p.props.map(([k, v]) => `${k}: ${v}`));
    e.currentTarget.href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(lines.join('\n'));
  });

  initPhotos(W.querySelector('.ph[data-owner=hero]'), 'hero');
  const fpPh = W.querySelector('.ph[data-owner=fpage]'); if (fpPh) initPhotos(fpPh, 'fpage');
  load();
  chargeUI();
  if (STORE) getCart().then(c => { CART = c; renderSum(); });
  earlyAdd();
  go(0, true);                           // photos are not kept across reloads, so a reload always restarts at step 1
  if (history.replaceState) history.replaceState(Object.assign({}, history.state, { wz: 0 }), '');
})();
